import type API from "@/Api/API";
import type { Subscription, SubscriptionDto } from "@/types/subscription";

export default class Subscriptions {
	api: API;

	constructor(api: API) {
		this.api = api;
	}

	async getSubscriptions(): Promise<Subscription[]> {
		return this.api
			.processRequest("GET", "/subscriptions")
			.then((res) => res.data);
	}

	async getSubscription(id: number): Promise<Subscription> {
		return this.api
			.processRequest("GET", `/subscriptions/${id}`)
			.then((res) => res.data);
	}

	async getDefaultSubscription(): Promise<Subscription> {
		return this.api
			.processRequest("GET", "/subscriptions/default/subscription")
			.then((res) => res.data);
	}

	async addSubscription(
		subscription: SubscriptionDto
	): Promise<Subscription> {
		return this.api
			.processRequest("POST", "/subscriptions", {
				data: subscription,
			})
			.then((res) => res.data);
	}

	async updateSubscription(
		id: number,
		subscription: SubscriptionDto
	): Promise<Subscription> {
		return this.api
			.processRequest("PUT", `/subscriptions/${id}`, {
				data: subscription,
			})
			.then((res) => res.data);
	}

	async deleteSubscription(id: number): Promise<void> {
		await this.api.processRequest("DELETE", `/subscriptions/${id}`);
	}

	async setUserSubscription(
		userUuid: string,
		subscriptionId: number | null
	): Promise<void> {
		await this.api.processRequest(
			"PUT",
			`/users/${userUuid}/subscription`,
			{
				data: { subscriptionId },
			}
		);
	}
}
